import * as React from 'react';
import { FilterField, FilterSection } from './FilterSection';
import { FilterSelect } from './FilterSelect';
import { RosterFilters } from './types';

/**
 * Who on the care team is responsible for the member.
 *
 * Two dropdowns as of round 8: Providers and Coach. The Providers dropdown is
 * no longer just MDs/DOs — NPs, Registered Dietitians, and Pharmacists are
 * all searchable from it too, per team feedback asking for one search field
 * across every clinician role rather than one dropdown per role
 * (`useCareTeamMember` builds the combined list; `matchesCareTeam` in
 * filters.ts checks a member's assignment across all three underlying
 * patient fields for a hit). The label stays "Providers" — it's the field
 * people already look at first, and everyone's join is by name either way.
 *
 * Providers and Coach AND against each other — selecting both asks for
 * members who have *both* (round 6's selection-logic framework; see
 * `matchesCareTeam`). Coach stays a separate dropdown and its own AND group
 * because it matches on id rather than name, and "my panel" is a different
 * question from "this provider's patients".
 *
 * Both dropdowns are single-select (Aug 2026 filter-logic pass) — one
 * provider, one coach at a time. That retires the OR-within-a-group half of
 * the framework above without touching the AND-across-groups half:
 * `matchesCareTeam` still takes arrays and still ANDs the two groups, it just
 * never sees more than one name in either.
 */
export const CareTeamSection = ({ filters }: { filters: RosterFilters }) => (
  <FilterSection title="Care Team">
    <FilterField label="Providers">
      <FilterSelect
        isMulti={false}
        placeholder="All"
        options={filters.providerOptions}
        selected={filters.selected.providers}
        onChange={(v) => filters.setFilter('providers', v)}
      />
    </FilterField>

    <FilterField label="Coach">
      <FilterSelect
        isMulti={false}
        placeholder="All"
        options={filters.coachOptions ?? []}
        selected={filters.selected.coaches}
        onChange={(v) => filters.setFilter('coaches', v)}
      />
    </FilterField>
  </FilterSection>
);
